module.exports = __webpack_public_path__ + "img/adv2.c3934691.png";